import { render, staticRenderFns } from "./TagWindow.vue?vue&type=template&id=37c83933&scoped=true&"
import script from "./TagWindow.vue?vue&type=script&lang=js&"
export * from "./TagWindow.vue?vue&type=script&lang=js&"
import style0 from "./TagWindow.vue?vue&type=style&index=0&id=37c83933&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c83933",
  null
  
)

export default component.exports